import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card8.scss';

class Card8 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Precificação de ativos ganha aprimoramentos - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card8-home page-gradient page-gradient--yellow bg-gray" ref="card8-home">
          <section className="iniciativas-area card8-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Precificação de ativos ganha aprimoramentos</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-8">
                              <p>
                                Após o crescimento de 77% da base de ativos precificados em dois anos – e o aumento de
                                22% no número de instituições que participam da atividade em 2020 – nossa agenda teve
                                como principal desafio identificar oportunidades de melhorias na precificação e na
                                divulgação diárias de valores de títulos públicos e privados, para estimular ainda mais
                                a liquidez no mercado secundário.
                              </p>
                              <p>
                                Dessa forma, iniciamos o desenvolvimento de uma metodologia específica para precificar
                                os FIDCs (Fundos de Investimento em Direitos Creditórios), que deverá ser concluída no
                                primeiro semestre de 2021, e reavaliamos as metodologias utilizadas na precificação dos
                                demais ativos: títulos públicos federais, debêntures, CRIs (Certificados de Recebíveis
                                Imobiliários) e CRAs (Certificados de Recebíveis do Agronegócio).
                              </p>
                            </div>
                            <div className="col-4 img-center h-img">
                              <img src={images.iniciativas.card8.img1} className="img1" />
                              <div className="rotate">
                                <img src={images.iniciativas.card8.linha1} className="linha1" />
                                <img src={images.iniciativas.card8.linha2} className="linha2" />
                                <img src={images.iniciativas.card8.seta} className="seta" />
                              </div>
                              <img src={images.iniciativas.card8.base} className="base" />
                              <img src={images.iniciativas.card8.col1} className="col1" />
                              <img src={images.iniciativas.card8.col2} className="col2" />
                              <img src={images.iniciativas.card8.col3} className="col3" />
                            </div>
                          </div>

                          <div className="col-12">
                            <p>
                              A partir daí, para dar ainda mais transparência aos nossos processos, disponibilizamos as
                              metodologias utilizadas em nosso site, seja em sua{' '}
                              <a href="http://anbi.ma/metprec" target="_blank">
                                versão completa
                              </a>
                              , seja na{' '}
                              <a href="http://anbi.ma/lamprec" target="_blank">
                                edição resumida
                              </a>
                              , com os principais procedimentos adotados.
                            </p>
                            <p>
                              Outro destaque do ano é o{' '}
                              <a
                                href="https://www.anbima.com.br/pt_br/informar/estatisticas/precos-e-indices/relatorio-de-precificacao.htm"
                                target="_blank"
                              >
                                Relatório de Precificação
                              </a>
                              , um novo informe que mostra os detalhes da composição das taxas publicadas para títulos
                              públicos federais, debêntures, CRIs e CRAs. Divulgado diariamente desde abril, o material
                              traz ainda o acompanhamento dos índices de renda fixa (
                              <a
                                href="https://www.anbima.com.br/pt_br/informar/precos-e-indices/indices/ima.htm#Laminas"
                                target="_blank"
                              >
                                IMA
                              </a>{' '}
                              e{' '}
                              <a
                                href="https://www.anbima.com.br/pt_br/informar/precos-e-indices/indices/ida.htm"
                                target="_blank"
                              >
                                IDA
                              </a>
                              ) e das curvas de crédito derivadas da precificação dos ativos.
                            </p>
                            <p>
                              Em 2020, aprimoramos também os processos de governança e investimos em sistemas internos
                              que agregassem novas tecnologias. Entre elas está a{' '}
                              <a
                                href="http://data.anbima.com.br/ferramentas/calculadora?_ga=2.165804028.353922647.1608557572-2011048849.1580934108"
                                target="_blank"
                              >
                                calculadora de CRI e CRA
                              </a>
                              , lançada em dezembro. A ferramenta é disponibilizada gratuitamente no ANBIMA Data e
                              permite que profissionais do mercado e investidores façam simulações das taxas e dos
                              preços desses ativos. A novidade contribui para as negociações de compra e venda e,
                              consequentemente, ajuda na promoção da liquidez desses papéis.
                              <br />
                              Nessa linha, avançamos também na precificação por meio de iniciativas como:
                            </p>
                          </div>

                          <div className="row">
                            <div className="col-3">
                              <ul>
                                <li>
                                  <p>
                                    Atualização do nosso nível de aderência às diretrizes da Iosco (Organização
                                    Internacional das Comissões de Valores Mobiliários);
                                  </p>
                                </li>
                              </ul>
                            </div>
                            <div className="col-3">
                              <ul>
                                <li>
                                  <p>
                                    Desenvolvimento de novas plataformas de coleta de insumos para precificação e
                                    aprimoramento da distribuição de dados (ANBIMA Feed);
                                  </p>
                                </li>
                              </ul>
                            </div>
                            <div className="col-3">
                              <ul>
                                <li>
                                  <p>Inclusão de novos dados analíticos no ANBIMA Data;</p>
                                </li>
                              </ul>
                            </div>
                            <div className="col-3">
                              <ul>
                                <li>
                                  <p>Treinamentos relacionados à utilização da planilha e sistema de envio.</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card8 };
